import { invariant } from '@seen/core/invariant'
import type { JSX } from 'react'
import { useParams } from 'react-router'
import { IncidentsPageComponent } from '#src/pages/shared/IncidentsPageComponent.tsx'

export function ParticipantIncidentsPage(): JSX.Element {
  const { patientId } = useParams()
  invariant(patientId, 'Patient ID is required')
  return <IncidentsPageComponent />
}
